module.exports = __webpack_public_path__ + "img/3.7b4d5fdd.jpg";